export default __webpack_public_path__ + "static/media/blue-gradient.8f8c3f41.jpeg";